const pagerdutyConfig = {
  appID: process.env.REACT_APP_PAGERDUTY_APP_ID,
};

export default pagerdutyConfig;
